import React, { Component } from 'react'
import './index.less'
import langM from './lang'
import {
    inject,
    observer,
    setDocumentTitle,
    setUidToken,
    getlang,
    setlang,

} from 'src/helper/devTools.js'
import VConsole from 'src/helper/vconsole'
import { jumpToStore, jumpToRoomNew } from '../../../helper/webviewFun'
import http from 'src/helper/http'
@inject('store')
@observer

export default class extends Component {
    constructor(props) {
        super(props)
        this.ruby = this.props.store.register('app/ruby')
    }

    state = {
        uid: 0,
        lang: langM.ar,
        language: 'en',
        setSeachValue: '',
        showEmpty: false,
        seachList: [],
        hostMemberList: [],
        guild_id: '',
        scroll: '0,20',
        setModalValue:true,
        selectItem:0,
        gid:null,
    }

    async componentWillMount() {
        let { language } = this.props.location.query
        language =await getlang(language)
        console.log('language', language)
        if (language == 'tr') {
            setDocumentTitle('İşçi Bayramınız Kutlu Olsun')
        }else{
            setDocumentTitle('Happy International Labor Day')
        }
        // lang 文字对象
        // language 语言种类 (zh/ar/en/tr)
        this.setState({
            lang: setlang(language, langM),
            language: language,
        })
        let uid = await setUidToken(this.props.location.query)
        
        await this.RunOnStart(uid)
    }

    // 初始化/接口请求初始化
    RunOnStart = async (uid) => {
       
        // 用户id
        this.setState({
            uid: uid
        })
        this.getRoomId()
    }
    
    getRoomId = async()=>{
        let res = await http.post('/withoutsign/room/top1')
        console.log(res)
        if (res.code == 0) {
            console.log(res.res.gid)
            this.setState({ gid:res.res.gid})
        }
    }
     
    componentDidMount() {
    }

    render() {
        let { language, gid } = this.state
        console.log(language,'.jpg',gid)
        return (
            <div className='labor-my'>
                <div className={language !='tr'?'labor-my-one':'labor-my-one-tr'}></div>
                <div className={language !='tr'?'labor-my-two':'labor-my-two-tr'}>
                    <div className='gift-one' onClick={()=>jumpToRoomNew(gid)}></div>
                    <div className='gift-two' onClick={()=>jumpToRoomNew(gid)}></div>
                    <div className='gift-three' onClick={()=>jumpToRoomNew(gid)}></div>
                </div>
                <div className={language !='tr'?'labor-my-three':'labor-my-three-tr'} >
                    <div className='go-head-store' onClick={()=>jumpToStore(0)}></div>
                </div>
                <div className={language !='tr'?'labor-my-four':'labor-my-four-tr'}>
                  <div className='go-car-store' onClick={()=>jumpToStore(1)}></div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// src/pages/activity/labor/index.js